const projectApi = require("api").project;

function appendScript(scriptId, file) {
  let url = typeof file === "string" ? file : URL.createObjectURL(file)
  try {
    scriptId = `script_${scriptId}`
    let oldScript = document.getElementById(scriptId)
    let newScript = document.createElement("script");
    newScript.setAttribute("id", scriptId);
    newScript.setAttribute("src", url);
    // newScript.setAttribute("async", true);
    // newScript.setAttribute("defer", true);
    newScript.setAttribute("type", "text/javascript");
    if (oldScript === null) {
      document.getElementsByTagName('head')[0].appendChild(newScript);
    } else {
      document.getElementsByTagName('head')[0].replaceChild(newScript, oldScript);
    }
    return Promise.resolve(newScript)
  } catch (err) {
    console.error(err)
    return Promise.reject(err)
  }
}

async function fetchModule(licenceUid, moduleKey, buildname) {
  return projectApi.module(licenceUid, moduleKey, buildname).catch(console.error)
}

module.exports = {
  async fetchModules(licenceUid, modules) {
    return Promise.all(modules.map(m => {
      return fetchModule(licenceUid, m.key, m.buildname)
    }))
  },
  async loadScript(licenceUid, moduleKey, scriptId, buildname) {
    return fetchModule(licenceUid, moduleKey, buildname).then(file => {
      return appendScript(scriptId, file);
    })
  },
  async unloadScript(scriptId) {
    try {
      scriptId = `script_${scriptId}`
      let script = document.getElementById(scriptId)
      document.getElementsByTagName('head')[0].removeChild(script)
    } catch (err) {
      console.error(err)
    }
  }
}
